// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"a2076657","254":"d1aa3e54","452":"70f1e2e0","557":"373353fa"}[chunkId] + ".css";
};